import { z } from 'zod';

export const updateSemenSchema = z.object({
  semenId: z.string(),
  semenType: z.string().nullable(),
  fertSiteId: z.string(),
  sireId: z.string().nullable(),
  donorScheduleDate: z.string(),
  accountId: z.string().nullable(),
  donorScheduleSemenLocation: z
    .string()
    .nullable()
    .refine((val) => val !== null, {
      message: 'Donor Schedule Semen Location is required',
    }),
  donorScheduleSemenType: z
    .string()
    .nullable()
    .refine((val) => val !== null, {
      message: 'Donor Schedule Semen Type is required',
    }),
  cane: z.string(),
  colCode: z.string(),
  naab: z.string(),
  recDate: z.string().nullable(),
  move: z
    .number()
    .nullable()
    .transform((val) => val ?? 0)
    .pipe(z.number().min(0, 'Move must be a positive number')),
  comment: z.string().nullable(),
  sexed: z.number().nullable(),
  sex: z.number().nullable(),
  storage: z.object({
    id: z.string(),
    name: z.string().nullable(),
  }),
  quantity: z.number(),
  cssCertified: z.number().nullable(),
  secondaryOwner: z.string().nullable().optional(),
});

export const createSemenSchema = z.object({
  semenType: z.string().min(1, 'Semen Type is required'),
  fertSiteId: z.string().min(1, 'Fert Site ID is required'),
  sireId: z.string().min(1, 'Sire ID is required'),
  donorScheduleDate: z.string().min(1, 'Donor Schedule Date is required'),
  accountId: z.string().min(1, 'Account ID is required'),
  donorScheduleSemenType: z
    .string()
    .min(1, 'Donor Schedule Semen Type is required'),
  cane: z.string().min(1, 'Cane Code is required'),
  colCode: z.string().min(1, 'Col Code is required'),
  naab: z.string().min(1, 'NAAB is required'),
  recDate: z.date(),
  available: z.number().min(0, 'Available must be a positive number'),
  move: z
    .number()
    .nullable()
    .transform((val) => val ?? 0)
    .pipe(z.number().min(0, 'Move must be a positive number')),
  comment: z.string().nullable(),
  sexed: z.string(),
  sex: z.string(),
  storage: z.object({
    id: z.string(),
    name: z.string().nullable(),
  }),
  cssCertified: z.string(),
  secondaryOwner: z.string().nullable().optional(),
});

export type UpdateSemen = z.infer<typeof updateSemenSchema>;
export type CreateSemen = z.infer<typeof createSemenSchema>;
